import {Injectable} from '@angular/core';
import {GenericServicesMotoristaService} from './generic-services-motorista.service';
import {MensagensService} from 'max-ng-lib';
import {HttpClient} from '@angular/common/http';

@Injectable({providedIn: 'root'})
export class RastreadorService extends GenericServicesMotoristaService {

	constructor(private _mensagensService: MensagensService,
				private _httpClient: HttpClient) {
		super();
	}

	getMensagensService(): MensagensService {
		return this._mensagensService;
	}

	getHttpClient(): HttpClient {
		return this._httpClient;
	}

	getUrlRecurso(): string {
		return '/rastreador';
	}

	listarTodos() {
		return this.get<any[]>('/listarTodos');
	}

	listarTodosSimplificado() {
		return this.get<any[]>('/listarSimplificado');
	}

	salvar(dadosParaSalvar) {
		return this.post<any[]>('/salvar', {dados: dadosParaSalvar});
	}

	validarCredenciais(dados) {
		return this.post<boolean>('/validarCredenciais', {dados});
	}
}
